// Public Portal - Shows PUBLISHED settings (no authentication required)
import React from 'react';
import { useParams } from 'react-router-dom';
import ClassListings from './ClassListings';
import PublicEnrollment from './PublicEnrollment';

const PublicPortal = () => {
  const { teacherId, classId } = useParams();

  // If classId is provided, show enrollment form
  if (classId) {
    return <PublicEnrollment classId={classId} />;
  }

  // Otherwise show published class listings
  return <ClassListings teacherId={teacherId} isDraft={false} />;
};

export default PublicPortal;